'use client';

export { default } from './SnackbarContent';
export { default as snackbarContentClasses } from './snackbarContentClasses';
export * from './snackbarContentClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SnackbarContent/index.js
// module id = 571
// module chunks = 25